import { makeStyles, tokens } from "@fluentui/react-components";

export const useDraftStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    "& button": {
      justifyContent: "flex-start",
    },
  },
});
